<template>
    <div id="konfigurator-pohyb">
        <h1 >Jak je {{ mazlicek.jmeno.value }} aktivní?</h1>

        <div v-show="!isAktivitaValid() && this.tryescape" class="info-messages-box">
            <div v-if="!isAktivitaValid() && this.tryescape" class="error-msg">Musíte vybrat aktivitu vašeho mazlíčka
            </div>
        </div>

        <div v-if="!mazlicek.jeStene" class="form-content">

            <div class="form-radios"
                 v-bind:class="{ 'has-error':!isAktivitaValid() && this.tryescape,'has-success':isAktivitaValid()  && this.tryescape}">
                <div class="form-type-radio" v-for="item in pohybItems">
                    <input type="radio" v-model="mazlicek.pohyb.id" v-bind:value="item.id" :id="item.id">
                    <label :for="item.id">
                        <div class="item-title">{{ item.title }}</div>
                        <div v-if="item.description.length > 0" class="item-desc" v-html="item.description"></div>
                    </label>
                </div>
            </div>
        </div>
        <info v-if="!mazlicek.jeStene" :krok="7"></info>

        <div v-else class="infobox">U dospělého psa zde vybíráte, jak je aktivní. U štěňat to pro výpočet Pettime není podstatné. Zvolte “Pokračovat”.</div>

        <confirmation-modal v-if="priceConfirmation.showModal"
                            :old-price="priceConfirmation.oldPrice" :new-price="priceConfirmation.newPrice"
                            :confirm-callback="updatePetAndQuit" @close="priceConfirmation.showModal = false"/>
        <navigace
                :showPrev="true"
                :onClickPrev="prev"
                :showNext="true"
                :disableNext="!valid"
                :onClickNext="next"
                :onClickSaveAndQuit="saveAndQuit"
        ></navigace>

    </div>
</template>

<script>
    import {validationMixin} from 'vuelidate'
    import {required} from 'vuelidate/lib/validators'
    import {apiSilex} from '../api'
    import navigace from './Navigace'
    import info from './Info'
    import ConfirmationModal from "./ConfirmationModal";

    export default {
        components: {ConfirmationModal, navigace, info},
        mixins: [validationMixin],
        data: function () {
            return {
                mazlicek: this.$store.state.mazlicek,
                pohybItems: [],
                tryescape: false,
                priceConfirmation: {
                    showModal: false,
                    differentPrice: false,
                    oldPrice: 0,
                    newPrice: 0,
                }
            }
        },
        computed: {
            valid: function () {
                return (this.mazlicek.pohyb.valid = !this.$v.mazlicek.pohyb.$invalid)
            }
        },
        methods: {
            prev: function () {
                this.$router.push({name: 'hmotnostkondice'})
            },
            updatePetAndQuit: function () {
                this.mazlicek.confirmToSave = false
                this.$store.dispatch('updatePet', this.mazlicek)
                  .then(response => {
                    this.$cookies.set('show_confirmation_message', 1)
                    window.location.href = 'opet-objednej/' + this.mazlicek.nid
                  }, error => {
                    console.error(error)
                  })
            },
            saveAndQuit: function () {
              if (this.isAktivitaValid()) {
                this.mazlicek.confirmToSave = true
                this.$store.dispatch('updatePet', this.mazlicek)
                  .then(response => {
                    const confirmation = response.data.data.priceConfirmation;
                    if (confirmation && confirmation.differentPrice) {
                        this.priceConfirmation.oldPrice = confirmation.oldPrice;
                        this.priceConfirmation.newPrice = confirmation.newPrice;
                        this.priceConfirmation.showModal = true
                    } else {
                        this.updatePetAndQuit()
                    }
                  }, error => {
                    console.error(error)
                  })
              } else {
                this.tryescape = true
                this.animateAfterError()
              }
            },
            next: function () {
                // this.$store.commit('setMazlicek', this.mazlicek)
                if (this.isAktivitaValid()) {
                    this.$store.dispatch('updatePet', this.mazlicek)
                        .then(response => {
                            this.$router.push({name: 'alergie'})
                        }, error => {
                            console.error(error)
                        })
                } else {
                    this.tryescape = true
                    this.animateAfterError()
                }
            },
            isAktivitaValid: function () {
                return this.mazlicek.pohyb.id !== null || this.mazlicek.jeStene
            },
            animateAfterError(){
                jQuery('html, body').animate({
                        scrollTop: jQuery('.app-content-left').offset().top - jQuery('#primary').height()
                    },
                    '500'
                )
            }
        },
        mounted: function () {
            this.mazlicek.step.current = 6
            this.$cookies.set('lastVisitedStep', 6)
            jQuery('html, body').animate({scrollTop: 0}, '500')
            apiSilex.get('/aktivita').then(response => (this.pohybItems = response.data))
        },
        validations: {
            mazlicek: {
                pohyb: {
                    id: {
                        required
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// 07Pohyb.vue?f1cfdaa4